
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/ai-feedback-student-writing-teacher-controlled-beats-chatbot",
      function () {
        return require("private-next-pages/c/blog-posts/ai-feedback-student-writing-teacher-controlled-beats-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/ai-feedback-student-writing-teacher-controlled-beats-chatbot"])
      });
    }
  